"use client";

import Image from "next/image";
import Link from "next/link";

export default function NotFound() {
  return (
    <div className="flex-1 bg-white min-h-screen">
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-4rem)] p-4">
        <div className="text-center">
          <div className="relative">
            <Image
              src="/dana-404.webp"
              alt="404 illustration"
              width={800}
              height={400}
              priority
              className="w-full max-w-2xl mx-auto"
            />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Page Not Found!
          </h2>
          <p className="text-gray-600 mb-8 max-w-md mx-auto">
            Sorry we can&apos;t seem to find the page you&apos;re looking for.
            There may be a misspelling in the URL entered, or the page you are
            looking for may no longer exist.
          </p>
          <Link
            href="/"
            className="inline-flex items-center justify-center px-6 py-3 text-sm font-medium text-white bg-primary hover:bg-primary/90 rounded-md transition-colors"
          >
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
